import React from 'react';
import { Router, Redirect, NotFound } from '~/utils';

import Session from './Session';
import Info from '~/info';

// import { Dashboard } from './Dashboard';
// import { DashboardList } from './DashboardList';

export default function PagesRoutes( props ) {
  return (
    <Router id="router">
      <Sessions path="/sessions" />
      <Redirect from="/session" to="/sessions" />
      <Session path="/session/:id" />
      <Info path="/info/*" />
      {/*
      <DashboardList path="/dashboard" />
      <Dashboard path="/dashboard/:id" />
      */}
      <NotFound default />
    </Router>
  );
}

// TODO
function Sessions() {
  return <div></div>;
}
